export default "__VITE_ASSET__BOMeMVoM__"